import React from 'react';

const FAQSection = () => {
  const faqs = [
    {
      question: "Which platforms do you support?",
      answer: "Lenscribe works with Flickr, SmugMug, and Unsplash. Connect your account with a single click using each platform's official OAuth — we never see your password."
    },
    {
      question: "How does the autonomous Agent work?",
      answer: "The Agent scans your Flickr, SmugMug, or Unsplash account at your chosen frequency — every 5 minutes to weekly. When it finds photos without titles or descriptions, it generates and applies metadata automatically. Configure it once and forget about it."
    },
    {
      question: "Will the Agent overwrite my existing metadata?",
      answer: "Never. The Agent only processes photos missing titles or descriptions. If a photo already has metadata, it's skipped entirely. Your existing content is always protected."
    },
    {
      question: "Are my photos and accounts safe?",
      answer: "We use each platform's official OAuth authorization — the same security as logging in directly. We never see your passwords, never download your photos to our servers, and only access metadata you explicitly approve."
    },
    {
      question: "Can I control what the Agent processes?",
      answer: "Yes. You can filter by tags, set scanning frequency, choose your AI style, and adjust description length. The Agent respects all your preferences and only processes photos matching your criteria."
    },
    {
      question: "Can I undo changes?",
      answer: "Yes. Click the \"Undo\" button in your job history to restore the original metadata for any photo."
    },
    {
      question: "How accurate is the AI?",
      answer: "We use OpenAI's latest vision models, trained to understand photo content, mood, location, and context. For manual processing you can preview and edit suggestions before applying."
    },
    {
      question: "Can I also process photos manually?",
      answer: "Yes. Use the Agent for automatic ongoing processing and the manual Photo Selection tool for one-time batch jobs. They work together seamlessly."
    },
  ];

  return (
    <section className="py-32 bg-stone-50" id="faq">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-serif text-3xl text-stone-900 text-center mb-12">
          Questions
        </h2>

        <div className="divide-y divide-stone-200">
          {faqs.map((faq, index) => (
            <div key={index} className="py-8">
              <h3 className="text-stone-900 font-medium mb-3">{faq.question}</h3>
              <p className="text-stone-500 text-sm leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
